import { ISelectOption } from '../../../UIPackage/MainModule/components/SelectInput';

export const unableToRefuseSelectOptions: ISelectOption<number>[] = [
  {
    id: 0,
    label: 'Профилактические визиты, от которых нельзя отказаться',
    value: true,
  },
  {
    id: 1,
    label: 'Кроме профилактических визитов, от которых нельзя отказаться',
    value: false,
  },
];
